export default __webpack_public_path__ + "static/media/twoSkipThumb.39b21132.png";